import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defaultMemoize } from 'reselect';
import _once from 'lodash/once';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import _stubFalse from 'lodash/stubFalse';
import { TableFieldWithActions } from '../../molecules/tableInputField';
import { REMOVE_ACTION } from '../../molecules/tableInputField/constants/general';
import withDragNDropTable from '../withDragNDropTable';
import { MULTI_SORT_HEADER_TITLE, FIELD_NAMES, TABLE_MANAGER_PROPS } from './multiSort.constants';
import { getOptionsFromColumns } from './multiSort.helpers';
import styles from './multiSort.module.scss';
import MULTI_SORT_COLUMNS from './columns';
export var getFormSections = _once(function () {
  return [{
    header: {
      label: MULTI_SORT_HEADER_TITLE,
      className: styles.sectionHeader
    },
    rows: [{
      className: styles.sortPreferenceContainer,
      id: 'sortPreferences',
      columns: [FIELD_NAMES.SORT_PREFERENCES]
    }]
  }];
});
var getActionsForRow = function getActionsForRow(props) {
  var original = props.original;
  if (original !== null && original !== void 0 && original.isLastRow) return [_objectSpread(_objectSpread({}, REMOVE_ACTION), {}, {
    disabled: true
  })];
  return _castArray(REMOVE_ACTION);
};
var getRowStyles = _once(function () {
  return {
    rowStyle: {
      height: '4.8rem'
    }
  };
});
var getTableRowKey = function getTableRowKey(_groupKey, rowProps) {
  return _get(rowProps, 'original.id');
};
var DragAndDropTable = withDragNDropTable(TableFieldWithActions);
export var getFormFields = defaultMemoize(function (columns, values) {
  return _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, {
    renderer: DragAndDropTable,
    renderOptions: {
      required: true,
      className: 'full-width',
      customTableComponentProps: getRowStyles,
      columns: MULTI_SORT_COLUMNS,
      getActionsForRow: getActionsForRow,
      tableManagerProps: TABLE_MANAGER_PROPS,
      getTableRowKey: getTableRowKey,
      shouldAddNewRow: _stubFalse,
      rowActionProps: {
        headerClassName: styles.columnHeader
      },
      additional: {
        sortableColumns: getOptionsFromColumns(columns, values)
      }
    }
  });
});